/* Worry-Free Shipping cart add-on — HollerBorn (2026-09-17)
 *
 * Loaded from layout/theme.liquid, NOT from the snippet. The cart drawer's contents arrive after page load
 * (section rendering + morphing), and a <script> inside injected HTML never executes — which is why the first
 * version fell through to the plain form and navigated to /cart when Michelle ticked the box in the drawer.
 * A document-level delegated listener loaded once in the layout survives every re-render.
 *
 * Behaviour:
 *   - click the box  → set variant 50616449958081 ($1.50) to quantity 1 or 0 via /cart/update.js
 *                      (ABSOLUTE by variant: never increments, adds the line if missing, never uses line numbers).
 *                      /cart/add.js increments (tick→untick→tick left quantity 2) and /cart/change.js 400s when the
 *                      line does not exist yet, so update.js is the only endpoint that does both halves safely.
 *   - OPT-IN (Michelle A26, 2026-10-16): the box starts EMPTY and nothing is ever added automatically. Google
 *                      treats a pre-added checkout charge as a pricing/consent violation (Merchant Center
 *                      answer/9158778) and a pre-ticked box is not consent in the UK. It was pre-ticked from 2026-09-17 until this change.
 *   - ticking sets a local opt-in flag; unticking clears it
 *   - cleanup: if the line is in the cart but THIS browser never ticked it (carts filled by the old pre-ticked
 *     version), it is removed once per page view
 *   - every failure path falls back to a reload, and the markup is a real <form> so it still works with JS off
 */
(function () {
  if (window.__wfInit) return;
  window.__wfInit = true;

  var VARIANT = 50616449958081;
  var OPT_IN = 'wf_optin';
  var cleanTried = false;

  try { window.localStorage.removeItem('wf_optout'); } catch (e) {}   // the pre-ticked version's key

  function optedIn() {
    try { return window.localStorage.getItem(OPT_IN) === '1'; } catch (e) { return false; }
  }
  function setOptIn(on) {
    try { on ? window.localStorage.setItem(OPT_IN, '1') : window.localStorage.removeItem(OPT_IN); } catch (e) {}
  }
  function host() { return document.querySelector('cart-items-component[data-section-id]'); }

  function apply(row, on) {
    var el = host();
    var sectionId = el ? el.dataset.sectionId : null;
    // /cart/update.js: absolute quantity keyed by VARIANT — adds when missing, removes at 0, never doubles.
    var updates = {};
    updates[VARIANT] = on ? 0 : 1;
    var body = { updates: updates };
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && sectionId ? data.sections[sectionId] : null;
        var fresh = html
          ? new DOMParser().parseFromString(html, 'text/html')
              .querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
          : null;
        if (!fresh || !el) { window.location.reload(); return; }
        el.replaceWith(fresh);
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wf-toggle]');
    if (!btn) return;
    var row = btn.closest('[data-wf]');
    if (!row) return;
    e.preventDefault();                 // never let the fallback form navigate
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    var on = row.dataset.wfOn === 'true';
    setOptIn(!on);                      // ticking = opt in; unticking = opt out
    apply(row, on);
  });

  // Opt-in only: take the line back out if this browser never ticked it. Never adds anything.
  function cleanUp() {
    if (cleanTried || optedIn()) return;
    var row = document.querySelector('[data-wf]');
    if (!row || row.dataset.wfOn !== 'true') return;
    cleanTried = true;
    apply(row, true);
  }

  if (document.readyState !== 'loading') cleanUp();
  document.addEventListener('DOMContentLoaded', cleanUp);
  new MutationObserver(cleanUp).observe(document.documentElement, { childList: true, subtree: true });
})();
